<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
                        <li class="breadcrumb-item page-header d-flex align-items-center">
                            <h4 class="mb-0">{{ $t('all_notifications') }}</h4>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="card border-0 card-with-shadow">
            <div class="card-body p-0">
                <app-table
                    id="notifications-table"
                    :options="tableOptions"
                    @action="action"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import { formatDateToLocal, getWebUrlFromDeepLink } from "../../../Helpers/Helpers";
    import { externalApiCall, urlGenerator } from "../../../Helpers/AxiosHelper";
    import { TableMixin } from "../../../../core/components/datatable/mixin/TableMixin";

    export default {
        name: "AllNotification",
        mixins: [TableMixin],
        data() {
            return {
                tableOptions: {
                    name: 'Notifications',
                    url: '/api/notifications',
                    datatableWrapper: true,
                    showHeader: true,
                    columns: [
                        {
                            title: this.$t('title'),
                            type: 'text',
                            key: 'title',
                            modifier: (value, row) => {
                                return `<span class="${row.read_at ? '' : 'font-weight-bold text-primary'}">${value}</span>`;
                            }
                        },
                        {
                            title: this.$t('body'),
                            type: 'text',
                            key: 'body',
                            modifier: (value, row) => {
                                const text = value || '';
                                return `<span class="${row.read_at ? 'text-muted' : 'font-weight-bold'}">${text.length > 50 ? text.substring(0, 50) + '...' : text}</span>`;
                            }
                        },
                        {
                            title: this.$t('date'),
                            type: 'text',
                            key: 'created_at',
                            modifier: (value) => formatDateToLocal(value)
                        },
                        {
                            title: this.$t('time'),
                            type: 'text',
                            key: 'created_at',
                            modifier: (value) => {
                                const settings = window.settings || { time_format: 'H' };
                                const format = settings.time_format === 'h' ? 'hh:mm A' : 'HH:mm';
                                return moment(value).local().format(format);
                            }
                        },
                        {
                            title: this.$t('action'),
                            type: 'action',
                            key: 'invoice',
                            isVisible: true
                        },
                    ],
                    showSearch: false,
                    showFilter: false,
                    paginationType: 'pagination',
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    actionType: "default",
                    actions: [
                        {
                            title: this.$t('view'),
                            type: 'none',
                            className: 'btn btn-sm btn-primary',
                            icon: 'eye',
                        }
                    ],
                },
            }
        },
        methods: {
            action(row, action, active) {
                if (action.title === this.$t('view')) {
                    this.readNotification(row);
                }
            },
            readNotification(notification) {
                let redirectUrl = notification.deep_link ? urlGenerator(getWebUrlFromDeepLink(notification.deep_link)) : null;
                
                if(!notification.read_at) {
                    externalApiCall('POST', `/api/notifications/${notification.id}/read`).then(() => {
                        notification.read_at = new Date();
                        this.$store.dispatch('getNotifications');
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    }).catch(() => {
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    });
                } else {
                    if (redirectUrl) {
                        window.location = redirectUrl;
                    }
                }
            },
        }
    }
</script>
